// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"0160aa45","422":"e0d3a89f","610":"1f003e8c","794":"57637bde","911":"2c08ba41","913":"e2bc8705","969":"ace453e7"}[chunkId] + ".chunk.js";
};